/**
 * `solarPlant` fields of the block project-extended-configuration.
 * Must match `ProjectExtendedConfigurationInput` in the API schema.
 */
export const PROJECT_EXTENDED_CONFIGURATION_INPUT_FIELDS = [
  'cascadeConnectionState',
  'electricMeterCombinationState',
  'electricMeterDeregistrationState',
  'electricMeterMountingState',
  'houseFuseAmpere',
  'houseFuseState',
  'islandOperationIntended',
  'measuringConcept',
  'motorStartup',
  'netOutputStates',
  'networkSupplyManagementPermanentRestrictionState',
  'networkSupplyManagementState',
  'networkSupplyManagementXOverState',
  'networkSupplyType',
  'solarPlantType',
  'storageCouplingState',
  'wireCrossSectionMainBus',
  'yearlyPower',
];

/** `ProjectExtendedConfigurationInput` from the project's solar plant: the 18 fields of the block. */
export const toProjectExtendedConfigurationInput = (solarPlant) =>
  Object.fromEntries(
    PROJECT_EXTENDED_CONFIGURATION_INPUT_FIELDS.map((field) => [field, solarPlant[field]])
  );
